export default __webpack_public_path__ + "static/media/proyectos.28e377bc.jpg";